import { render } from "./DashboardExpertVx.vue?vue&type=template&id=660099cd&scoped=true"
import script from "./DashboardExpertVx.vue?vue&type=script&lang=js"
export * from "./DashboardExpertVx.vue?vue&type=script&lang=js"

import "./DashboardExpertVx.vue?vue&type=style&index=0&id=660099cd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660099cd"]])

export default __exports__